import { useEffect, useState } from 'react';
import { gsap } from 'gsap';

export const useIntro = (
	linearFunc: (value: number, start: number, end: number, min: number, max: number) => number
) => {
	const [scrollTop, setScrollTop] = useState<number>(0);
	const [scrollEnd, setScrollEnd] = useState<number>(0);

	const introKeyvisualTrans = (scrollTop: number) => {
		const bgY = Math.floor(linearFunc(scrollTop, 0, 900, 0, 234));
		const bg = document.querySelector('.intro .cont1 .scroll-bg');
		if (bg) {
			gsap.to(bg, {
				duration: 0,
				y: -bgY
			});
		}
	};

	const handleScroll = () => {
		const scrollEndValue = document.documentElement.scrollHeight - window.innerHeight;
		setScrollTop(window.scrollY);
		setScrollEnd(scrollEndValue);
		introKeyvisualTrans(window.scrollY);
	};

	const introAddScrollTrigger = () => {
		const introTitle = document.querySelectorAll('.intro .title-group p > span');
		const introTitleLen = introTitle.length;
		gsap.killTweensOf(introTitle);
		gsap.to(introTitle, { duration: 0, y: 100, opacity: 0, color: '#3A3A3A' });
		for (let i = 0; i < introTitleLen; i++) {
			const item = introTitle[i];
			gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					start: '0% 100%',
					end: '100% 100%',
					scrub: 1
				},
				y: 0,
				opacity: 1,
				color: '#fff',
				duration: 0.6,
				ease: 'Cubic.easeOut',
				delay: 0.6 * i
			});
		}

		const introStella = document.querySelectorAll('.intro .cont1 .text-box');
		gsap.killTweensOf(introStella);
		gsap.to(introStella, { duration: 0, y: 100, opacity: 0 });
		gsap.to(introStella, {
			scrollTrigger: {
				trigger: introStella,
				start: '90% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut',
			delay: 0.6
		});
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);

		const initialScrollTop = window.scrollY;
		setScrollTop(initialScrollTop);
		setScrollEnd(document.documentElement.scrollHeight - window.innerHeight);
		introKeyvisualTrans(initialScrollTop);
		introAddScrollTrigger();
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return { scrollTop, scrollEnd };
};
